import { render, staticRenderFns } from "./CompanyDesktopTakenCompany.vue?vue&type=template&id=34c35ee2"
import script from "./CompanyDesktopTakenCompany.vue?vue&type=script&lang=js"
export * from "./CompanyDesktopTakenCompany.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports